module.exports = __webpack_public_path__ + "img/zip.465f85f1.png";